import { tooltipClasses } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { TbNote, TbNotes } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { softColors } from "@/constants/colors";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { PassengersGroupTableRow } from "@/types/tasks.types";

export type PlanNotesColumnProps = {
    t: TFunction;
    textClassName?: string;
};

export const PlanNotesColumn = ({ t, textClassName }: PlanNotesColumnProps): GridColDef<PassengersGroupTableRow> => {
    return {
        field: "notes",
        headerName: t("notes"),
        minWidth: 280,
        headerAlign: "center",
        cellClassName: "!overflow-hidden !whitespace-nowrap",
        renderHeader: (params) => <TableHeader Component={TbNote} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => row.notes,
        renderCell: ({ value }: GridRenderCellParams<PassengersGroupTableRow>) => (
            <RenderCell value={value} textClassName={textClassName} />
        ),
    };
};

function RenderCell({ value, textClassName }: { value: string; textClassName?: string }) {
    return (
        <NoMaxWidthTooltip
            arrow
            sx={{
                [`& .${tooltipClasses.tooltip}`]: {
                    backgroundColor: "white",
                    border: "none",
                    padding: "0px !important",
                    fontSize: 12,
                    maxWidth: "260px !important",
                },
            }}
            title={
                <HotelStatusTooltip
                    status={{
                        ...softColors.brown,
                        component: () => TbNotes,
                        tooltip: {
                            title: "Yolcu Notu",
                            description: value,
                        },
                    }}
                />
            }
        >
            <span className={textClassName}> {value}</span>
        </NoMaxWidthTooltip>
    );
}
